module.exports = __webpack_public_path__ + "/images/logo-cta-siglo.808d4b9.png";